// Creating types for client details
export interface IClientDetails {
  imageUrl: string
  clientName: string
  clientAdmin: {
    clientEmail: string
  }
  clientAddress: string
  country: string
  state: string
  city: string
  zipcode: string
  clientDuns: string
  EDIRecordingSync: boolean
  isEdiEnrollmentRequired: boolean
  isCopyUan: boolean
  dialInNumber: [{dialInNumber: string; position: any; dialInNoError: string}]
}

// Creating types for Brand Info
// export interface IBrandInfo {
//   brandName: string
//   brandEmailId: []
//   emailError: string
//   brandError: string
//   disable: string
// }
type BrandAdmin = {
  id: string
  emailId: string
}

// Define the type for a single brand
export type IBrandInfo = {
  name: string
  id: string
  brandAdmin: BrandAdmin[]
}
// Creating types for Pricing Setup
export interface IPricingSetup {
  setupFees: number
  monthlyFees: number
  perMin: number
  perTpv: number
  monthlyMin: number
  lateChargeFees: number
  salesTax: number
  stripeFees: number
  creditType: 'PERPETUAL_CREDIT' | 'ONE_TIME_CREDIT'
  creditAmount: number
}

// Creating for Notes
export interface INotes {
  inputText: string
}

export interface AddClientData {
  [x: string]: any
  clientInfo: IClientDetails
  brandInfo: IBrandInfo[]
  pricingSetup: IPricingSetup
  notesInfo: INotes
}

export type FeesField = {
  fieldLabel: string
  fieldName: any
  data: any
  updateData: Function
  required?: boolean
  hasError?: boolean
}

export const defaultAddClientData: AddClientData = {
  clientInfo: {
    imageUrl: '',
    clientName: '',
    clientAdmin: {clientEmail: ''},
    clientAddress: '',
    country: 'US',
    city: '',
    state: '',
    zipcode: '',
    clientDuns: '',
    EDIRecordingSync: false,
    isEdiEnrollmentRequired: false,
    isCopyUan: false,
    dialInNumber: [{dialInNumber: '', position: 0, dialInNoError: ''}],
  },
  brandInfo: [],
  pricingSetup: {
    setupFees: 0,
    monthlyFees: 0,
    perMin: 0,
    perTpv: 0,
    monthlyMin: 0,
    lateChargeFees: 0,
    salesTax: 0,
    stripeFees: 0,
    creditType: 'ONE_TIME_CREDIT',
    creditAmount: 0,
  },
  notesInfo: {inputText: ''},
  clientSettings: {
    enableNoTPV: false,
    googleSearch: false,
    billImages: false,
    transcribedResponse: false,
    liveAgents: false,
    textTPV: false,
    liveAgentCustomerDetailsEditable: false,
    smsTPV: false,
    smsD2D: false,
    emailD2D: false,
    outboundLiveAgent: false,
    enableApiCheck: false,
    enableDynamicProductCreation: false,
    enableContractStartDateStartDate: false,
    isUtilityMeterNumberRequired: false,
    billUploadOnlyByCamera: false,
    disableExistingCustomerEnrollment: false,
    enableLineTypeIntelligence: false,
    enableZipCodeInUtility:false,
    enableCustomerReportToSalesChannel:false,
    enableContractRequired: false,
  },
  liveAgentNumberEnglish: {
    languageId: '',
    liveAgentDialInNumber: '',
    vendorId: '',
    forwardingNumber: '',
  },
  liveAgentNumberSpanish: {
    languageId: '',
    liveAgentDialInNumber: '',
    vendorId: '',
    forwardingNumber: '',
  },
  outboundLiveAgentDialInNumberEng: {
    languageId: '',
    liveAgentDialInNumber: '',
    vendorId: '',
  },
  outboundLiveAgentDialInNumberSpn: {
    languageId: '',
    liveAgentDialInNumber: '',
    vendorId: '',
  },
  optInMessage: '',
  outboundLiveAgentFailMsg: '',
}

export const feesTextField = [
  {
    name: 'setupFees',
    label: 'Setup Fees',
  },
  {
    name: 'monthlyFees',
    label: 'Monthly Fees',
  },
  {
    name: 'perTpv',
    label: '$ Per TPV',
  },
  {
    name: 'perMin',
    label: '$ Per Min',
  },
  {
    name: 'monthlyMin',
    label: 'Monthly Minimums',
  },
  {
    name: 'lateChargeFees',
    label: 'Late Charge Fees',
  },
  {
    name: 'salesTax',
    label: 'Sales Tax',
  },
  {
    name: 'stripeFees',
    label: 'Stripe Fees',
  },
]

export const feesRadioField = [
  {
    name: 'ONE_TIME_CREDIT',
    label: 'One Time Credit',
  },
  {
    name: 'PERPETUAL_CREDIT',
    label: 'Prepetual Credit',
  },
]
export type StepProps = {
  data: AddClientData
  updateData: (fieldsToUpdate: Partial<AddClientData>) => void
  hasError: boolean
  setHasError?: any
  isDisabled: boolean
  emailValidate?: string
  setEmailValidate?: any
  style?: any
  validation?: any
  callBack?: any
  setNotes?: any
  notes?: any
  setDialInNoValidation?: any
  dialInNoValidation?: any
  setEmailDisabled?: any
  emailDisabled?: any
  setdialInNumber?: any
  dialInNumber?: any
  updatedData?: any
  refreshList?: any
  setImageURL?: any
  setDeleteCall?: any
  deleteCall?: any
  // type: 'Edit' | 'Add'
  setBrandsInfo?: any
  originalEmail?: any
}

// Define the User interface
export type User = {
  id: string
  emailId: string
}

// Define the Brand interface
export type Brand = {
  name: string
  id: string
  brandAdmin: User[]
}
